import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  HomeComponent,
  HomeModule,
} from '@nibtravel/quote/common/feature-shell/home';
import { Route } from '@nibtravel/shared/util/constants';
import {
  CanActivateChildFeatureGuard,
  Features,
  FeatureToggleModule,
} from '@nibtravel/shared/util/feature-toggle';
import { QuoteType } from '@nibtravel/shared/util/models';

import { QuoteParamGuard } from './quote-param.guard';

export const AppRoutes: Routes = [
  {
    path: Route.Empty,
    pathMatch: 'full',
    redirectTo: Route.Home,
  },
  {
    path: 'quote/turnstile', //Todo: Rename badly named route - from TIDAU site
    loadChildren: (): Promise<any> =>
      import('@nibtravel/quote/common/features/loader').then(
        (x) => x.QuoteLoaderModule
      ),
    canActivate: [QuoteParamGuard],
    data: {
      ignoreLoader: true,
    },
  },
  {
    path: 'quote/:id/compare', // Link from Email
    loadChildren: (): Promise<any> =>
      import('@nibtravel/quote/common/features/loader').then(
        (x) => x.QuoteLoaderModule
      ),
    canActivate: [QuoteParamGuard],
    data: {
      ignoreLoader: true,
    },
  },
  {
    path: 'quote/:id/:planId/options', // Link from Email with selected plan
    loadChildren: (): Promise<any> =>
      import('@nibtravel/quote/common/features/loader').then(
        (x) => x.QuoteLoaderModule
      ),
    canActivate: [QuoteParamGuard],
    data: {
      ignoreLoader: true,
    },
  },
  {
    path: Route.AMT,
    component: HomeComponent,
    canActivateChild: [CanActivateChildFeatureGuard],
    data: {
      featureId: Features.HomeShellId,
      tripType: QuoteType.MultiTrip,
    },
  },
  {
    path: Route.Home,
    component: HomeComponent,
    canActivateChild: [CanActivateChildFeatureGuard],
    data: {
      featureId: Features.HomeShellId,
    },
  },
  {
    path: Route.Quote,
    canActivateChild: [CanActivateChildFeatureGuard],
    loadChildren: (): Promise<any> =>
      import('@nibtravel/quote/common/feature-shell/quote').then(
        (x) => x.QuoteModule
      ),
  },
  {
    path: Route.Confirmation,
    canActivateChild: [CanActivateChildFeatureGuard],
    loadChildren: (): Promise<any> =>
      import('@nibtravel/quote/confirmation/feature-shell/confirmation').then(
        (x) => x.ConfirmationModule
      ),
  },
  {
    path: '**',
    loadChildren: (): Promise<any> =>
      import('@nibtravel/shared/feature-shell/not-found').then(
        (x) => x.NotFoundModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutes, {
      enableTracing: false,
      scrollPositionRestoration: 'top',
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'corrected',
    }),
    HomeModule,
    FeatureToggleModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static forRoot(isProd: boolean): ModuleWithProviders<AppRoutingModule> {
    return {
      ngModule: AppRoutingModule,
      providers: [
        {
          provide: IS_PROD,
          useValue: isProd,
        },
      ],
    };
  }
}

export const IS_PROD = new InjectionToken<string>('IS_PROD');
